module.exports = __webpack_public_path__ + "img/report_fx_pz.bb88402d.png";